<template>
  <div class="myInviteData" v-loading="loading">
    <h3 class="headerTitle">邀请交易数据</h3>
    <el-card class="mt-15" shadow="never">
      <div class="card-header" slot="header">
        <el-date-picker
          v-model="timeRange"
          type="daterange"
          size="small"
          @change="dateChange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-link type="primary" class="entry" @click="checkFlowDetail(null)">查看明细</el-link>
      </div>
      <div class="card-content">
        <div class="card-content-item">
          <div class="amount">
            <span class="amount-num">{{ tradeData.tradeAmount | decimal }}</span>
            <span class="amount-unit">元</span>
          </div>
          <div class="label">交易总金额</div>
        </div>
        <div class="card-content-item">
          <div class="amount">
            <span class="amount-num">{{ tradeData.tradeCount }}</span>
            <span class="amount-unit">笔</span>
          </div>
          <div class="label">交易总笔数</div>
        </div>
        <div class="card-content-item">
          <div class="amount">
            <span class="amount-num">{{ tradeData.finshAmount | decimal }}</span>
            <span class="amount-unit">元</span>
          </div>
          <div class="label">已结算总金额</div>
        </div>
        <div class="card-content-item">
          <div class="amount">
            <span class="amount-num">{{ tradeData.finshCount }}</span>
            <span class="amount-unit">笔</span>
          </div>
          <div class="label">已结算总笔数</div>
        </div>
      </div>
    </el-card>
    <el-table class="mt-15" :data="flowList">
      <el-table-column
        prop="merName"
        label="商家名称">
      </el-table-column>
      <el-table-column
        prop="tradeAmount"
        label="交易总金额(元)">
        <template slot-scope="scope">
          ￥{{scope.row.tradeAmount | decimal}}
        </template>
      </el-table-column>
      <el-table-column
        prop="tradeCount"
        label="交易总笔数(笔)">
      </el-table-column>
      <el-table-column
        prop="finshAmount"
        label="结算总金额(元)">
        <template slot-scope="scope">
          ￥{{scope.row.finshAmount | decimal}}
        </template>
      </el-table-column>
      <el-table-column
        prop="finshCount"
        label="结算总笔数(笔)">
      </el-table-column>
      <el-table-column
        label="时间">
        <template slot-scope="scope">
          {{scope.row.statisticDay | formatTime('yyyy-MM-dd HH:mm')}}
        </template>
      </el-table-column>
      <el-table-column
        label="时间">
        <template slot-scope="scope">
          <el-link type="primary" @click="checkFlowDetail(scope.row)">明细</el-link>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="{ total, pageSize, currentPage: pageIndex }" @callFather="handlePageChange"></Pagination>
    <flow-detail ref="detail"></flow-detail>
  </div>
</template>

<script type="text/ecmascript-6">
import { fetchInviteDataFlow,fetchInviteSummery } from '../../../api/xunyou';
import Pagination from '@/components/Pagination';
import FlowDetail from './myInviteFlowDetail';
export default {
  name: 'myInviteData',
  components: {
    Pagination,
    FlowDetail
  },
  data() {
    return {
      endDateTime: new Date().getTime(),
      timeRange: [],
      tradeData: '',
      pageIndex: 1,
      pageSize: 10,
      flowList:[],
      total: 0,
      loading: false
    }
  },
  computed: {
    userId () {
      return this.$store.getters.userId;
    }
  },
  created() {
    this.initPrevOneDay();
    this.getTradeSummery();
    this.search();
  },
  methods: {
    // 日期改变拉取数据
    dateChange (e) {
      console.log('选择得日期：', e);
      this.timeRange = e;
      this.getTradeSummery();
      this.search();
    },
    // 查看明细
    checkFlowDetail (data) {
      if (!data) {
        data = this.tradeData;
      }
      this.$refs.detail.show({
        time: this.timeRange,
        data: data
      });
    },
    // 初始化前一天日期时间
    initPrevOneDay () {
      const oneDayTime = 1000 * 60 * 60 *24;
      const nowTime = new Date().getTime();
      const prevTime = nowTime - oneDayTime;
      const prevDate = new Date(prevTime);
      const prevDateStr = this.$utils.formatTime(prevDate, 'yyyy-MM-dd');
      this.timeRange = [prevDateStr, prevDateStr];
    },
    // 按日期汇总数据
    getTradeSummery () {
      const params = {
        recommUid: this.userId,
        statisticDayStart: this.$utils.formatTime(this.timeRange[0], 'yyyy-MM-dd'),
        statisticDayEnd: this.$utils.formatTime(this.timeRange[1], 'yyyy-MM-dd')
      }
      this.loading = true;
      fetchInviteSummery(params).then(res => {
        console.log('日期区间数据：', res);
        if (res.code === 0) {
          this.tradeData = res.data;
        }
      }).catch(err => {
        console.error('错误：', err);
      }).finally(() => {
        this.loading = false;
      });
    },
    search () {
      this.pageIndex = 1;
      this.getTradeFlow();
    },
    handlePageChange (val) {
      this.pageSize = val.pageSize;
      this.pageIndex = val.currentPage;
      this.getTradeFlow();
    },
    // 按日期明细数据
    getTradeFlow () {
      const params = {
        pageNum: this.pageIndex,
        pageSize: this.pageSize,
        recommUid: this.userId,
        statisticDayStart: this.$utils.formatTime(this.timeRange[0], 'yyyy-MM-dd'),
        statisticDayEnd: this.$utils.formatTime(this.timeRange[1], 'yyyy-MM-dd')
      }
      fetchInviteDataFlow(params).then(res => {
        console.log('交易列表：', res);
        if (res.code === 0) {
          this.total = res.total;
          this.flowList = res.rows;
        }
      }).catch(err => {
        console.error('错误：', err);
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
/deep/ .el-card__header{
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.card-header{
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-content{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .card-content-item{
    flex: 1;
    text-align: center;
    .amount-num{
      font-size: 30px;
    }
    .label{
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/myOrder/myInvite/myInviteData.vue